import React from 'react';


/* _frfr-universal-components UNICOMPO UNIVERSAL SMALL ELEMENTS/COMPONENTS */
/*
UniPaper
PROPS:
props.fullWidth
props.overflowHidden
props.extraClass
*/

/*
https://mui.com/material-ui/react-paper/

*/

const UniPaper = (props) => {
  let cl = '';
  if (props.fullWidth === true) { // width to 100%
    cl = " unicompo-limiter--full-width";
  }
  if (props.overflowHidden === true) { // overflow: hidden;
    cl = " unicompo-limiter--overflow-hidden";
  }
  let extraClass = '';
  if (typeof props.extraClass === 'string') {
    extraClass = ' ' + props.extraClass;
  }
  return (
    <div className={'unicompo-paper' + cl + extraClass}>{props.children}</div>
  );
};

export default UniPaper;